goog.provide('el8.uiwidget.GroupedNav');

goog.require('el8.template.uiwidget.GroupedNav');
goog.require('el8.util.amplitude.helpers');


/**
 * This is a vertical tabbed-navigation widget, where N tabs
 * can be grouped together under <=N labels.
 *
 * For an example, see the Letter selectAttachments dialog.
 */
el8.uiwidget.GroupedNav = function(spec) {

    spec = spec || {};

    this._SELECTED_CLASS = 'el8NavMenuItemSelected ebs-active';
    this._DESELECTED_CLASS = 'el8NavMenuItem';

    this._navContainer = spec.navContainer;
    this._contentContainer = spec.contentContainer;

    this._showingSection = null;
    this._initFnMap = {};
    this._showFnMap = {};
    this._hideFnMap = {};
};
el8.uiwidget.GroupedNav.prototype.init = function(opts) {

    opts = opts || {};

    opts.groups = opts.groups || [];

    for (var i=0; i<opts.groups.length; i++) {
        this.addGroup(opts.groups[i]);
    }

    var that = this;
    this._navContainer.on('click', '.grouped-nav-item',  function() {
        var name = $(this).attr('data-name');
        if (name !== that._showingSection) {
            that.showSection(name);
        }
    });

};
el8.uiwidget.GroupedNav.prototype.addGroup = function(spec) {
    var title = spec.title || null;

    var $group = $(el8.template.uiwidget.GroupedNav.groupNav({title: title}));
    this._navContainer.append($group);

    var sections = spec.sections || [];
    for (var i=0; i<sections.length; i++) {
        this.addSection($group, sections[i]);
    }
};

el8.uiwidget.GroupedNav.prototype.addSection = function($group, sectionSpec) {
    var name = sectionSpec.name;
    $group.append(
        el8.template.uiwidget.GroupedNav.sectionNav({
            name: name,
            label: sectionSpec.label,
            isBeta: sectionSpec.isBeta || false,
            isNew: sectionSpec.isNew || false
        })
    );
    this._contentContainer.append(
        el8.template.uiwidget.GroupedNav.sectionContent({
            name: name
        })
    );
    if (sectionSpec.initFn) {
        this._initFnMap[name] = _.once(sectionSpec.initFn);
    }
    if (sectionSpec.showFn) {
        if (sectionSpec.isBeta) {
          // Hi-jacking the section show function for sections with beta prop in order to send
          // event to amplitude
          function showBetaTab() {
            console.log('Amplitude', 'New feature settings: ' + sectionSpec.label)
            el8.util.amplitude.setUserProperty('New feature settings: ' + sectionSpec.label, 'discovered')
            if (sectionSpec.showFn) {
              sectionSpec.showFn.apply(this, arguments);
            }
          }
          this._showFnMap[name] = showBetaTab;
        } else {
          this._showFnMap[name] = sectionSpec.showFn;
        }
    }
    if (sectionSpec.hideFn) {
        this._hideFnMap[name] = sectionSpec.hideFn;
    }
    this.hideSection(name);
};

/**
 * Show and hide a group's tab in the LHS
 * (Used to prevent a group from being visible/clickable)
 */
el8.uiwidget.GroupedNav.prototype.showSectionTab = function(name) {
    var $tab = $('.grouped-nav-item[data-name="'+name+'"]', this._navContainer);
    $tab.show();
    $tab.closest('.grouped-nav-title').show();
};
el8.uiwidget.GroupedNav.prototype.hideSectionTab = function(name) {
    var $tab = $('.grouped-nav-item[data-name="'+name+'"]', this._navContainer);
    $tab.hide();
    // if none of this group's peers are visible, hide the group's title
    // [$.is(':visible') will return true if any item in the list is visible]
    if (!$tab.siblings('.grouped-nav-item').is(':visible')) {
        $tab.closest('.grouped-nav-title').hide();
    }
};

/**
 * Show and hide a group's content in the RHS
 * (Represents clicking on a tab)
 */
el8.uiwidget.GroupedNav.prototype.showSection = function(name) {

    if (this._showingSection) {
        this.hideSection(this._showingSection);
    }

    var $groupedNavItem = $('.grouped-nav-item[data-name="'+name+'"]', this._navContainer);
    if (!$groupedNavItem.length) { return; }
    $groupedNavItem.removeClass(this._DESELECTED_CLASS).addClass(this._SELECTED_CLASS);

    var $content = $('.grouped-nav-content[data-name="'+name+'"]', this._contentContainer);
    if (this._initFnMap[name]) { this._initFnMap[name].call(this, $content, name); }
    if (this._showFnMap[name]) { this._showFnMap[name].call(this, $content, name); }
    $content.show();

    this._showingSection = name;
};
el8.uiwidget.GroupedNav.prototype.hideSection = function(name) {
    $('.grouped-nav-item[data-name="'+name+'"]', this._navContainer)
        .addClass(this._DESELECTED_CLASS)
        .removeClass(this._SELECTED_CLASS);
    var $content = $('.grouped-nav-content[data-name="'+name+'"]', this._contentContainer);
    $content.hide();
    if (this._hideFnMap[name]) { this._hideFnMap[name].call(this, $content, name); }
    this._showingSection = null;
};

el8.uiwidget.GroupedNav.prototype.hasSection = function(name) {
    var $groupedNavItem = $('.grouped-nav-item[data-name="'+name+'"]', this._navContainer);
    return $groupedNavItem.length;
};

el8.uiwidget.GroupedNav.prototype.getShowingSection = function() {
    return this._showingSection;
};

el8.uiwidget.GroupedNav.prototype.getGroupElt = function(title) {
    return $('.grouped-nav-title[data-title="'+title+'"]', this._navContainer);
};
